import React from "react";
import { TopTrendingPodcastsTemplate } from "themes/administration/analytics/components";

function TopTrendingPodcasts(props) {
    return <TopTrendingPodcastsTemplate {...props} />;
}

export default TopTrendingPodcasts;
